module.exports = __webpack_public_path__ + "img/XMR.d1b41b97.svg";